
import React, { Component } from 'react';
import styled from 'styled-components';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';

import { ListProvider, ListContext } from 'core/ListProvider';
import { SequenceDisplay } from 'core/Display';

const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledCounterpartyListItem = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-gap: 15px;
  margin-bottom: 30px;
  
  h3 {
    margin: 0 0 10px 0;
    font-weight: 500;
    font-size: 18px;
  }
  
  .info {
    color: #828282;
    margin-bottom: 20px;
  }
`;

const StyledContactItem = styled.div`
  margin-bottom: 14px;
  display: flex;
  align-items: center;
    
  span {
    margin-right: 5px;
  }
  
  .icon {
    font-size: 12px;
    color: #828282;
    
    svg { font-size: 1.2rem; }
  }
  
  .gray {
    color: #828282;
  }
`;


class ContactItem extends Component {
  render() {
    const { contact } = this.props;
    return (
      <StyledContactItem>
        <span className={'icon'}><PersonOutlineOutlinedIcon /></span>
        <span>{contact.name}{(contact.phone || contact.email) && (',')}</span>
        {contact.phone && <span className={'gray'}>{contact.phone}{contact.email && (',')}</span>}
        {contact.emails.map((email, index) =>
          <React.Fragment key={index}>
            <a href={`mailto:${email}`} className={'gray'}>{email}</a>
            {(index + 1) < contact.emails.length ? <span className={'gray'}>, </span> : ''}
          </React.Fragment>
        )}
      </StyledContactItem>
    )
  }
}


export class CounterpartyListItem extends Component {
  render() {
    const { counterparty, index } = this.props;
    const info = [
      counterparty.inn ? `ИНН ${counterparty.inn}` : undefined,
      counterparty.kpp ? `КПП ${counterparty.kpp}` : undefined,
      counterparty.tariff ? `тариф ${counterparty.tariff.name}` : undefined,
    ];
    const info2 = [
      counterparty.head_name ? counterparty.head_name : undefined,
      counterparty.head_post ? `(${counterparty.head_post})` : undefined
    ];

    return (
      <StyledCounterpartyListItem>
        <div>
          <Index>{index + 1}</Index>
        </div>
        <div>
          <h3>{counterparty.name}</h3>
          <div className={'info'}>
            <SequenceDisplay values={info} separator={', '} />
          </div>

          {(counterparty.head_name || counterparty.head_post) && (
            <div className={'info'}>
              Руководитель: <SequenceDisplay values={info2} separator={' '}/>
            </div>
          )}

          {counterparty.address && (
            <div className={'info'}>{counterparty.address}</div>
          )}

          {counterparty.contacts.map(item =>
            <ContactItem key={item.id} contact={item} />
          )}
        </div>
      </StyledCounterpartyListItem>
    )
  }
}


export default class CounterpartyList extends Component {

  render() {
    const { client } = this.props;
    return (
      <ListProvider
        url={'client/counterparty'}
        filterDefaults={{
          client: client.id
        }}
      >
        <ListContext.Consumer>
          {context => {
            const { items } = context;
            return (
              <React.Fragment>
                {items.map((item, index) =>
                  <CounterpartyListItem
                    key={item.id}
                    counterparty={item}
                    index={index}
                  />
                )}
              </React.Fragment>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
